
export default function capitalize() {
    return function capitalizeFilter(input) {
        if (input !== undefined) {
            input = input.toLowerCase();
            return input.substring(0, 1).toUpperCase() + input.substring(1);
        }
        return input;
    };
}



// WEBPACK FOOTER //
// ./src/app/common/angular/filters/capitalize.filter.js